module.exports = __webpack_public_path__ + "images/emoji/hamster.b9563d09568d719f83b6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/hamster.png
// module id = B6nm
// module chunks = 14